/**
 * Product card image gallery — horizontal scroll with prev/next arrows.
 * Matches Shopify-style card media browsing on collection/grid cards.
 */
(function () {
  if (customElements.get('card-gallery')) return;

  class CardGallery extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.track = this.querySelector('[data-card-gallery-track]');
      this.slides = this.querySelectorAll('[data-card-gallery-slide]');
      this.prevBtn = this.querySelector('[data-card-gallery-prev]');
      this.nextBtn = this.querySelector('[data-card-gallery-next]');
      if (!this.track || this.slides.length < 2) return;

      this.index = 0;
      this.prevBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.go(-1);
      });
      this.nextBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.go(1);
      });

      this.track.addEventListener(
        'scroll',
        () => {
          window.requestAnimationFrame(() => this.syncFromScroll());
        },
        { passive: true }
      );

      this.updateButtons();
    }

    go(delta) {
      const next = Math.max(0, Math.min(this.slides.length - 1, this.index + delta));
      this.index = next;
      const slide = this.slides[next];
      if (slide) {
        slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }
      this.updateButtons();
    }

    syncFromScroll() {
      if (!this.track || !this.slides.length) return;
      const left = this.track.scrollLeft;
      const width = this.track.clientWidth || 1;
      const i = Math.round(left / width);
      this.index = Math.max(0, Math.min(this.slides.length - 1, i));
      this.updateButtons();
    }

    updateButtons() {
      if (this.prevBtn) this.prevBtn.disabled = this.index <= 0;
      if (this.nextBtn) this.nextBtn.disabled = this.index >= this.slides.length - 1;
    }
  }

  customElements.define('card-gallery', CardGallery);
})();
